import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import './vaccination-check.scss';

@customElement('sbk-vaccination-check')
export class SbkVaccinationCheck extends LitElement {

  protected createRenderRoot() {
    return this;
  }
}